/* eslint-disable no-catch-shadow */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-quotes */
/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useRef, useState } from 'react';
import {
  SafeAreaView,
  StyleSheet,
  View,
  FlatList,
  InteractionManager,
  RefreshControl,
} from 'react-native';
import { theme } from '../theme/theme';
import { useDispatch, useSelector } from 'react-redux';
import {
  enableRefreshControl,
  fetchCanteen,
  resetCanteen,
} from '../store/canteen.slice';
import { AnimatedFAB, Card, Searchbar, Text } from 'react-native-paper';
import CategoryItems from '../components/Canteen/CategoryItems';
import CategoriesModal from '../components/Canteen/CategoriesModal';
import CartFooter from '../components/Canteen/CartFooter';
import HttpLoader from '../components/HttpLoader';

/**
 * Main component for displaying a canteen's menu and categories.
 * Handles fetching canteen data, searching, and category navigation.
 * @param {object} navigation - Navigation prop for screen navigation
 * @param {object} route - Route prop for accessing params
 */
function Canteen({ navigation, route, title, hideCartFooter }) {
  const dispatch = useDispatch();
  const flatListRef = useRef(null);
  const [interactionCompleted, setIntersectionCompleted] = useState(false);
  const [visibleCategoriesModal, setVisibleCategoriesModal] = useState(null);
  const categories = useSelector(state => state.canteen.categories);
  const canteen = useSelector(state => state.canteen.canteen);
  const refreshing = useSelector(state => state.canteen?.refreshing);
  const cartCanteen = useSelector(state => state.cart.canteens?.[canteen?.canteen_id]);
  const status = useSelector(state => state.canteen.status);
  const error = useSelector(state => state.canteen.error);
  const [searchQuery, setSearchQuery] = useState('');

  /**
   * Handles initial interaction completion and canteen reset on unmount.
   */
  useEffect(() => {
    const task = InteractionManager.runAfterInteractions(async () => {
      setIntersectionCompleted(true);
      console.log('cartCanteen', cartCanteen);
    });
    return () => {
      task.cancel();
      dispatch(resetCanteen());
    };
  }, []);

  /**
   * Fetches canteen data when interaction is complete or on refresh.
   */
  useEffect(() => {
    if (interactionCompleted) {
      dispatch(fetchCanteen({ canteen_id: route?.params?.canteen_id }));
    }
  }, [interactionCompleted, refreshing]);


  /**
   * Renders a single category's items in the FlatList.
   * @param {object} param0 - Contains item and index
   */
  const renderItem = ({ item, index }) => (
    <CategoryItems
      searchQuery={searchQuery}
      canteen={{
        ...canteen,
      }}
      category={item}
    />
  );

  /**
   * Handles closing the categories modal.
   * @param {boolean} _visible - Modal visibility
   */
  const onCategoryModalClose = _visible => {
    setVisibleCategoriesModal(_visible);
  };

  /**
   * Scrolls the FlatList to the selected category index.
   * @param {number} index - Index to scroll to
   */
  const scrollToItem = index => {
    onCategoryModalClose(false);
    setTimeout(() => {
      flatListRef.current?.scrollToIndex({ index, animated: true });
    }, 500);
  };

  /**
   * Returns the RefreshControl component for pull-to-refresh.
   */
  const _refreshControl = () => {
    return (
      <RefreshControl
        colors={[theme.colors.primary]}
        refreshing={refreshing}
        onRefresh={() => _onRefresh()}
      />
    );
  };

  /**
   * Handles pull-to-refresh action.
   * @param {boolean} retry - Optional retry flag
   */
  const _onRefresh = retry => {
    dispatch(enableRefreshControl({ retry }));
  };

  return (
    <SafeAreaView edges={['bottom']} style={styles.container}>
      {interactionCompleted && (
        <React.Fragment>
          <HttpLoader status={status} errorHandler={_onRefresh} error={error} />
          {status === 'succeeded' && (
            <React.Fragment>
              <View style={styles.mainContainer}>
                <View style={{ marginBottom: 1 }}>
                  <Card
                    elevation={0}
                    style={{ backgroundColor: '#fff', borderRadius: 4 }}>
                    <Card.Content>
                      {title && (<Text variant="titleMedium" style={{ marginBottom: 8, textTransform: 'capitalize' }}>{title}</Text>)}
                      <Searchbar
                        placeholder="Search"
                        onChangeText={setSearchQuery}
                        value={searchQuery}
                      />
                    </Card.Content>
                  </Card>
                </View>
                <FlatList
                  ref={flatListRef}
                  data={categories}
                  renderItem={renderItem}
                  refreshControl={_refreshControl()}
                  keyExtractor={(item, index) => (item?.category_id).toString()}
                  contentContainerStyle={{ paddingBottom: 96 }}
                />
                {categories.length > 0 && (
                  <React.Fragment>
                    {
                      <CategoriesModal
                        visible={visibleCategoriesModal}
                        onCategorySelect={scrollToItem}
                        onCategoryModalClose={onCategoryModalClose}
                      />
                    }
                    <AnimatedFAB
                      icon={'text-box-outline'}
                      onPress={() => setVisibleCategoriesModal(t => !t)}
                      animateFrom={'right'}
                      iconMode={'static'}
                      color="#ffffff"
                      style={[
                        styles.fabStyle,
                        { backgroundColor: theme.colors.primary },
                      ]}
                    />
                  </React.Fragment>
                )}
              </View>
              {!hideCartFooter && <CartFooter />}
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f1f1f3',
  },
  mainContainer: {
    flex: 1,
    margin: 4,
  },
  countersContainer: {
    flex: 1,
    borderRadius: 8,
    padding: 8,
    margin: 4,
  },
  recommendedContainer: {
    // flex: 1,
    borderRadius: 8,
    padding: 8,
    margin: 4,
  },
  slideContainer: {
    flex: 1,
    height: 144,
    margin: 4,
    borderRadius: 8,
    backgroundColor: '#ffffff',
  },
  slide: {
    backgroundColor: 'rgba(20,20,200,0.3)',
    height: 200,
    width: '100%',
  },
  br6: {
    borderWidth: 1,
    borderColor: '#f1f1f3',
    borderBottomEndRadius: 6,
    borderBottomStartRadius: 6,
  },
  item: {
    flex: 1,
    marginVertical: 4,
    paddingHorizontal: 4,
  },
  coverImage: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    backgroundColor: '#ffffff',
  },
  ribbon: {
    position: 'absolute',
    top: 0,
    left: 0,
    paddingVertical: 2,
    paddingHorizontal: 6,
    borderTopLeftRadius: 6,
    backgroundColor: theme.colors.primary,
  },
  fabStyle: {
    bottom: 8,
    right: 16,
    position: 'absolute',
    borderRadius: 64,
  },
});

export default Canteen;
